var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45249 4.19352C5.45249 3.96192 5.26474 3.77417 5.03314 3.77417C4.80154 3.77417 4.61379 3.96192 4.61379 4.19352V15.3424L2.81354 13.5422C2.64977 13.3784 2.38425 13.3784 2.22048 13.5422C2.05671 13.7059 2.05671 13.9714 2.22048 14.1352L4.14355 16.0583C4.63486 16.5496 5.43142 16.5496 5.92273 16.0583L7.8458 14.1352C8.00957 13.9714 8.00957 13.7059 7.8458 13.5422C7.68203 13.3784 7.41651 13.3784 7.25274 13.5422L5.45249 15.3424V4.19352Z",
    fill: "#626768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 14.2581C10.4844 14.4897 10.6721 14.6774 10.9037 14.6774H17.6134C17.845 14.6774 18.0328 14.4897 18.0328 14.2581C18.0328 14.0265 17.845 13.8387 17.6134 13.8387H10.9037C10.6721 13.8387 10.4844 14.0265 10.4844 14.2581Z",
    fill: "#626768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 10.0645C10.4844 9.83289 10.6721 9.64514 10.9037 9.64514H15.0973C15.3289 9.64514 15.5166 9.83289 15.5166 10.0645C15.5166 10.2961 15.3289 10.4839 15.0973 10.4839H10.9037C10.6721 10.4839 10.4844 10.2961 10.4844 10.0645Z",
    fill: "#626768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 5.87095C10.4844 5.63935 10.6721 5.4516 10.9037 5.4516H12.5811C12.8128 5.4516 13.0005 5.63935 13.0005 5.87095C13.0005 6.10256 12.8128 6.29031 12.5811 6.29031H10.9037C10.6721 6.29031 10.4844 6.10256 10.4844 5.87095Z",
    fill: "#626768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort_ascending.8a59027c276b412b2ccc29a4f2217b39.svg";
export { ForwardRef as ReactComponent };